import { ChangeDetectionStrategy, Component, inject, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { ENVIRONMENT_TOKEN } from "@intocare/environments";
import { LanguageModule } from "@intocare/language";

import { SupportInfo, SupportInfoBannerComponent } from "../support-info-banner/support-info-banner.component";

@Component({
	selector: "ic-contact",
	templateUrl: "./contact.component.html",
	styleUrls: ["./contact.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [LanguageModule, TranslateModule, SupportInfoBannerComponent],
})
export class ContactComponent {
	private readonly environment = inject(ENVIRONMENT_TOKEN);

	supportInfo = input<SupportInfo>();

	protected supportLink = this.environment.SUPPORT;
	protected whatsNewUrl = this.environment.WHATS_NEW;
}
